import BaseAPI from "../api";

const path: string = "/notification";
export type listItem = {
  status?: string;
  group_status?: boolean;
  limit?: number;
  page?: number;
};
export class NotiApi extends BaseAPI {
  static list(param: listItem): Promise<any> {
    return this.api.get(`${path}`, { params: { ...param } });
  }
  static patch(id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`);
  }
  
}